import { render, staticRenderFns } from "./select-candidate.vue?vue&type=template&id=31d44e4c&"
import script from "./select-candidate.vue?vue&type=script&lang=js&"
export * from "./select-candidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports